export const environment = {
  production: false,
  apiBaseUrl: '',
  cognito: {
    issuer: 'https://cognito-idp.sa-east-1.amazonaws.com/sa-east-1_kBw7H56Yq',
    domain: 'https://sa-east-1kbw7h56yq.auth.sa-east-1.amazoncognito.com',
    clientId: '63r3ug9832iv3cv7ansgcgmp3p',
    redirectUri: 'https://dashtemp.helipagos.ar/auth/callback',
    logoutUri: 'https://dashtemp.helipagos.ar/logout',
    scopes: 'openid email phone'
  }
};
